import { render, staticRenderFns } from "./DeleteLayoutModal.vue?vue&type=template&id=6301668c&scoped=true"
import script from "./DeleteLayoutModal.vue?vue&type=script&lang=js"
export * from "./DeleteLayoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6301668c",
  null
  
)

export default component.exports